module.exports = __webpack_public_path__ + "static/media/ic-badge-membro.d2280751.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Icons Network/ic-badge-membro.svg
// module id = 193
// module chunks = 0